import { render, staticRenderFns } from "./ProductIntroduction.vue?vue&type=template&id=8d1db6ee&scoped=true"
import script from "./ProductIntroduction.vue?vue&type=script&lang=js"
export * from "./ProductIntroduction.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroduction.vue?vue&type=style&index=0&id=8d1db6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1db6ee",
  null
  
)

export default component.exports